import { render } from "./NewTestItemResult.vue?vue&type=template&id=aeb5363a&scoped=true"
import script from "./NewTestItemResult.vue?vue&type=script&lang=js"
export * from "./NewTestItemResult.vue?vue&type=script&lang=js"

import "./NewTestItemResult.vue?vue&type=style&index=0&id=aeb5363a&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb5363a"]])

export default __exports__